var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSeatBlocked = function SvgSeatBlocked(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.5C7.60761 0.5 6.27225 1.05312 5.28769 2.03769C4.30312 3.02226 3.75 4.35761 3.75 5.75V8.75C2.95435 8.75 2.19129 9.06607 1.62868 9.62868C1.06607 10.1913 0.75 10.9544 0.75 11.75V18.5C0.75 19.2956 1.06607 20.0587 1.62868 20.6213C2.19129 21.1839 2.95435 21.5 3.75 21.5H14.25C15.0456 21.5 15.8087 21.1839 16.3713 20.6213C16.9339 20.0587 17.25 19.2956 17.25 18.5V11.75C17.25 10.9544 16.9339 10.1913 16.3713 9.62868C15.8087 9.06607 15.0456 8.75 14.25 8.75V5.75C14.25 2.85 11.9 0.5 9 0.5ZM12.75 8.75V5.75C12.75 4.75544 12.3549 3.80161 11.6517 3.09835C10.9484 2.39509 9.99456 2 9 2C8.00544 2 7.05161 2.39509 6.34835 3.09835C5.64509 3.80161 5.25 4.75544 5.25 5.75V8.75H12.75Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSeatBlocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "seat-blocked.870a64d2f6a35f7b65e300f423a394fd.svg";